import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const AdminOnlyRoute = ({ children }) => {
  const { currentUser, userProfile, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <div className="text-sm text-gray-600">Loading...</div>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/" replace />;
  }

  const isAdmin =
    userProfile?.is_admin === true ||
    userProfile?.role === "admin" ||
    userProfile?.user_type === "admin";

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminOnlyRoute;
